<template>
  <div class="white mb--16px border--1px border--solid border--gray border--lighten-3 position--relative">
    <div class="form-container">

      <!-- 해당 엘리먼트 클릭시 .form-container__content에 is-selected 삭제 / 기본이 .form-container__content에 is-selected 붙어 있음. -->
      <div
        class="p--28px"
        role="button"
      >
        <text-field-title
          :label="label"
          :required="required"
        ></text-field-title>

        <!-- iconname이 Edit2.vue 파일(외부)에서 제어가 가능해야 한다. / 변경요망 -->
        <!-- 펼쳐진 상태 iconname="remove" / 숨기기 상태 iconname="add"  -->
        <form-button
          class="btn__icon btn--lg position--absolute top--15px right--28px border--1px border--solid border--gray border--lighten-3 text--gray font--24px"
          :icon="isShow ? 'remove' : 'add'"
          @click="toggle"
        ></form-button>
      </div>

      <!-- is-selected 클래스 추가시 콘텐츠 보임 / is-selected 삭제시 콘텐츠 숨김  -->
      <div
        class="form-container__content"
        :class="isShow ? 'is-selected' : ''"
      >
        <div class="p--28px  border-t--1px border--solid border--gray border--lighten-3">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    required: { type: Boolean, default: false }
  },
  data () {
    return {
      isShow: true
    }
  },
  methods: {
    toggle () {
      this.isShow = !this.isShow
    }
  },
  components: {
    TextFieldTitle: () => import('@/component/ui2/textfield/TextFieldTitle'),
    FormButton: () => import('@/component/ui2/button/FormButton')
  }
}
</script>
